import { ragToCardVariantMap } from "../../constants";
import Card from "../Card";
import RagMetricCard from "../RagMetricCard";

export type GlobalEvidenceProps = {
    evidenceMissingCount: number;
    evidenceExpiringInNext30DaysCount: number;
    evidenceInDateCount: number;
};

const GlobalEvidence = ({
    evidenceMissingCount,
    evidenceExpiringInNext30DaysCount,
    evidenceInDateCount,
}: GlobalEvidenceProps) => {
    const evidenceRag =
        evidenceMissingCount > 0
            ? "red"
            : evidenceExpiringInNext30DaysCount > 0
            ? "amber"
            : "green";

    return (
        <Card variant={ragToCardVariantMap[evidenceRag]} className="p-4">
            <div className="grid space-y-6 md:space-y-0 md:grid-cols-3 md:gap-6">
                <RagMetricCard
                    title="In date evidence"
                    value={evidenceInDateCount}
                    variant="green"
                />
                <RagMetricCard
                    title="Expiring within 30 days"
                    value={evidenceExpiringInNext30DaysCount}
                    variant="amber"
                />
                <RagMetricCard
                    title="Missing evidence"
                    value={evidenceMissingCount}
                    variant="red"
                />
            </div>
        </Card>
    );
};

export default GlobalEvidence;
